var map = {
	"./accordion-cmp-extended": "e3ec",
	"./accordion-cmp-extended.vue": "e3ec",
	"./aspect-ratio-box-cmp": "b23f",
	"./aspect-ratio-box-cmp.vue": "b23f",
	"./banner-cmp": "aebf",
	"./banner-cmp.vue": "aebf",
	"./beautiful-date": "d234",
	"./beautiful-date.vue": "d234",
	"./breadcrumbs-cmp": "df41",
	"./breadcrumbs-cmp.vue": "df41",
	"./card-cmp": "78d6",
	"./card-cmp.vue": "78d6",
	"./card-product-cmp": "3ba7",
	"./card-product-cmp.vue": "3ba7",
	"./card-product-spec-item-cmp": "1e96",
	"./card-product-spec-item-cmp.vue": "1e96",
	"./card-product-specs-cmp": "8eba",
	"./card-product-specs-cmp.vue": "8eba",
	"./carousel-brands-brand-cmp": "7a4f",
	"./carousel-brands-brand-cmp.vue": "7a4f",
	"./carousel-brands-cmp": "a5a8",
	"./carousel-brands-cmp.vue": "a5a8",
	"./carousel-certifications-cmp": "ab9d",
	"./carousel-certifications-cmp.vue": "ab9d",
	"./carousel-images-cmp": "4de5",
	"./carousel-images-cmp.vue": "4de5",
	"./carousel-posts-cmp": "97dc",
	"./carousel-posts-cmp.vue": "97dc",
	"./carousel-product-banners-cmp": "0e79",
	"./carousel-product-banners-cmp.vue": "0e79",
	"./carousel-product-cards-cmp": "2e71",
	"./carousel-product-cards-cmp.vue": "2e71",
	"./chef-contest-form": "6886",
	"./chef-contest-form.vue": "6886",
	"./chefs-note-banner-cmp": "a08a",
	"./chefs-note-banner-cmp.vue": "a08a",
	"./colored-box": "9998",
	"./colored-box.vue": "9998",
	"./configurations-component/global-config": "f8da",
	"./configurations-component/global-config.vue": "f8da",
	"./configurations-component/local-config": "efc1",
	"./configurations-component/local-config.vue": "efc1",
	"./configurations-component/news-and-media-config": "853e",
	"./configurations-component/news-and-media-config.vue": "853e",
	"./configurations-component/products-config": "8776",
	"./configurations-component/products-config.vue": "8776",
	"./configurations-component/recipes-config": "5e40",
	"./configurations-component/recipes-config.vue": "5e40",
	"./configurations-component/services-config": "d325",
	"./configurations-component/services-config.vue": "d325",
	"./contact-form/contact-form-back-cta-cmp": "624c",
	"./contact-form/contact-form-back-cta-cmp.vue": "624c",
	"./contact-form/contact-form-cmp": "9afd",
	"./contact-form/contact-form-cmp.vue": "9afd",
	"./contact-form/contact-form-fiscal-info-cmp": "1834",
	"./contact-form/contact-form-fiscal-info-cmp.vue": "1834",
	"./contact-form/contact-form-message-info-cmp": "20d4",
	"./contact-form/contact-form-message-info-cmp.vue": "20d4",
	"./contact-form/contact-form-personal-info-cmp": "ef72",
	"./contact-form/contact-form-personal-info-cmp.vue": "ef72",
	"./contact-form/contact-form-stepper-cmp": "e01c",
	"./contact-form/contact-form-stepper-cmp.vue": "e01c",
	"./cooking-tips-best-practices-detail-page": "cd79",
	"./cooking-tips-best-practices-detail-page.vue": "cd79",
	"./cooking-tips-best-practices-page": "3f5e",
	"./cooking-tips-best-practices-page.vue": "3f5e",
	"./cooking-tips-materials-page": "3045",
	"./cooking-tips-materials-page.vue": "3045",
	"./cooking-tips-static-cmp": "d7e3",
	"./cooking-tips-static-cmp.vue": "d7e3",
	"./cooking-tips-videos-page": "59b4",
	"./cooking-tips-videos-page.vue": "59b4",
	"./cta-box-cmp": "9602",
	"./cta-box-cmp.vue": "9602",
	"./cta-button-cmp-extended": "b354",
	"./cta-button-cmp-extended.vue": "b354",
	"./dropdown-cmp-extended": "ef7f",
	"./dropdown-cmp-extended.vue": "ef7f",
	"./event-info-cmp": "ee2c",
	"./event-info-cmp.vue": "ee2c",
	"./face-to-face-cmp": "fa65",
	"./face-to-face-cmp.vue": "fa65",
	"./figure-card-cmp": "d4d8",
	"./figure-card-cmp.vue": "d4d8",
	"./focus-items-cmp": "5813",
	"./focus-items-cmp.vue": "5813",
	"./focus-items-nutrition-allergens-cmp": "f15b",
	"./focus-items-nutrition-allergens-cmp.vue": "f15b",
	"./focus-items-tab-content-cmp": "940b",
	"./focus-items-tab-content-cmp.vue": "940b",
	"./footer-banner": "fa76",
	"./footer-banner.vue": "fa76",
	"./footer-cmp": "27fd",
	"./footer-cmp.vue": "27fd",
	"./gigya/gigya-config": "3f65",
	"./gigya/gigya-config.vue": "3f65",
	"./gigya/gigya-gtm-handler": "d561",
	"./gigya/gigya-gtm-handler.vue": "d561",
	"./gigya/gigya-initializer": "74f4",
	"./gigya/gigya-initializer.vue": "74f4",
	"./gigya/gigya-menu-item": "17e7",
	"./gigya/gigya-menu-item.vue": "17e7",
	"./gigya/gigya-screen": "b112",
	"./gigya/gigya-screen.vue": "b112",
	"./grid-column-cmp": "ca62",
	"./grid-column-cmp.vue": "ca62",
	"./grid-container-cmp": "44db",
	"./grid-container-cmp.vue": "44db",
	"./grid-row-cmp": "8d21",
	"./grid-row-cmp.vue": "8d21",
	"./guidelines-cmp": "7b86",
	"./guidelines-cmp.vue": "7b86",
	"./header-cmp": "79a2",
	"./header-cmp.vue": "79a2",
	"./hero-al-bronzo-cmp": "2473",
	"./hero-al-bronzo-cmp.vue": "2473",
	"./hero-cmp": "2cf6",
	"./hero-cmp.vue": "2cf6",
	"./highlighted-image-cmp": "396b",
	"./highlighted-image-cmp.vue": "396b",
	"./highlighted-video-cmp": "1e54",
	"./highlighted-video-cmp.vue": "1e54",
	"./icon-text-info-cmp": "a79a",
	"./icon-text-info-cmp.vue": "a79a",
	"./image-cmp": "def1",
	"./image-cmp.vue": "def1",
	"./info-dropdown-cmp": "678c",
	"./info-dropdown-cmp.vue": "678c",
	"./ingredients-steps-list-cmp": "a162",
	"./ingredients-steps-list-cmp.vue": "a162",
	"./input-checkbox-cmp-extended": "e486",
	"./input-checkbox-cmp-extended.vue": "e486",
	"./input-file-cmp-extended": "dad5",
	"./input-file-cmp-extended.vue": "dad5",
	"./input-radio-cmp-extended": "35bb",
	"./input-radio-cmp-extended.vue": "35bb",
	"./input-text-cmp-extended": "be01",
	"./input-text-cmp-extended.vue": "be01",
	"./js-loader": "df91",
	"./js-loader.vue": "df91",
	"./landing-banner-cmp": "0b68",
	"./landing-banner-cmp.vue": "0b68",
	"./landing-banner-content-cmp": "0c48",
	"./landing-banner-content-cmp.vue": "0c48",
	"./language-modal-cmp": "cc07",
	"./language-modal-cmp.vue": "cc07",
	"./loading-cmp": "5641",
	"./loading-cmp.vue": "5641",
	"./main-image-cmp": "53f0",
	"./main-image-cmp.vue": "53f0",
	"./media-download-cmp": "ac77",
	"./media-download-cmp.vue": "ac77",
	"./media-player-cmp": "de3e",
	"./media-player-cmp.vue": "de3e",
	"./menu-item-cmp": "105a",
	"./menu-item-cmp.vue": "105a",
	"./menu-subitem-cmp": "80f2",
	"./menu-subitem-cmp.vue": "80f2",
	"./modal-cmp": "e7d2",
	"./modal-cmp.vue": "e7d2",
	"./my-simple-example-page": "0ad6",
	"./my-simple-example-page.vue": "0ad6",
	"./my-spa-example-page": "2d3b",
	"./my-spa-example-page.vue": "2d3b",
	"./news-and-media-app-hook/news-and-media-detail-page": "1f36",
	"./news-and-media-app-hook/news-and-media-detail-page.vue": "1f36",
	"./news-and-media-app-hook/news-and-media-list-page": "d5d1",
	"./news-and-media-app-hook/news-and-media-list-page.vue": "d5d1",
	"./news-and-media-app-hook/news-and-media-list-tab-page": "2e8c",
	"./news-and-media-app-hook/news-and-media-list-tab-page.vue": "2e8c",
	"./news-and-media-app-hook/news-and-media-page": "b370",
	"./news-and-media-app-hook/news-and-media-page.vue": "b370",
	"./newsletter-form-cmp": "981b",
	"./newsletter-form-cmp.vue": "981b",
	"./one-trust": "4152",
	"./one-trust.vue": "4152",
	"./pagination-cmp": "9d4e",
	"./pagination-cmp.vue": "9d4e",
	"./pasta-parallax-wrapper-cmp": "1a92",
	"./pasta-parallax-wrapper-cmp.vue": "1a92",
	"./picture-cmp": "1781",
	"./picture-cmp.vue": "1781",
	"./podcast-link-cmp": "8530",
	"./podcast-link-cmp.vue": "8530",
	"./product-modal-cmp": "b5be",
	"./product-modal-cmp.vue": "b5be",
	"./products-app-hook/first-level-category-page": "f4c2",
	"./products-app-hook/first-level-category-page.vue": "f4c2",
	"./products-app-hook/product-detail-page": "f6f2",
	"./products-app-hook/product-detail-page.vue": "f6f2",
	"./products-app-hook/second-level-category-page": "a542",
	"./products-app-hook/second-level-category-page.vue": "a542",
	"./profitability-calculator-cmp": "ce69",
	"./profitability-calculator-cmp.vue": "ce69",
	"./profitability-calculator-wrapper-cmp": "30b5",
	"./profitability-calculator-wrapper-cmp.vue": "30b5",
	"./quote-cmp": "a795",
	"./quote-cmp.vue": "a795",
	"./recaptcha-cmp": "2fe8",
	"./recaptcha-cmp.vue": "2fe8",
	"./recipes-app-hook/nutrition-modal-cmp": "770b",
	"./recipes-app-hook/nutrition-modal-cmp.vue": "770b",
	"./recipes-app-hook/recipe-detail-page": "4a22",
	"./recipes-app-hook/recipe-detail-page.vue": "4a22",
	"./recipes-app-hook/recipes-footer-cmp": "008b",
	"./recipes-app-hook/recipes-footer-cmp.vue": "008b",
	"./recipes-app-hook/recipes-hub-page": "2421",
	"./recipes-app-hook/recipes-hub-page.vue": "2421",
	"./recipes-app-hook/recipes-list-page": "74d6",
	"./recipes-app-hook/recipes-list-page.vue": "74d6",
	"./scroll-x-navbar-cmp": "1d42",
	"./scroll-x-navbar-cmp.vue": "1d42",
	"./search-modal-cmp": "f602",
	"./search-modal-cmp.vue": "f602",
	"./select-cmp-extended": "42c3",
	"./select-cmp-extended.vue": "42c3",
	"./side-by-side-cmp": "6e06",
	"./side-by-side-cmp.vue": "6e06",
	"./simple-card-cmp": "1bc1",
	"./simple-card-cmp.vue": "1bc1",
	"./slider-cmp-extended": "2b0b",
	"./slider-cmp-extended.vue": "2b0b",
	"./social-share-cmp": "3ad1",
	"./social-share-cmp.vue": "3ad1",
	"./social-share-item": "9f65",
	"./social-share-item.vue": "9f65",
	"./step-card-cmp": "f894",
	"./step-card-cmp.vue": "f894",
	"./submit-cmp-extended": "c8f7",
	"./submit-cmp-extended.vue": "c8f7",
	"./sustainability-banner-cmp": "450c",
	"./sustainability-banner-cmp.vue": "450c",
	"./svg-icons-cmp": "da2d",
	"./svg-icons-cmp.vue": "da2d",
	"./table-cell-cmp": "34ae",
	"./table-cell-cmp.vue": "34ae",
	"./table-cmp": "d5f4",
	"./table-cmp.vue": "d5f4",
	"./table-row-cmp": "6420",
	"./table-row-cmp.vue": "6420",
	"./tabs-cmp": "9e7b",
	"./tabs-cmp.vue": "9e7b",
	"./tag-cmp": "058e",
	"./tag-cmp.vue": "058e",
	"./text-with-cmp": "e151",
	"./text-with-cmp.vue": "e151",
	"./textarea-cmp-extended": "b93f",
	"./textarea-cmp-extended.vue": "b93f",
	"./title-format-al-bronzo-cmp": "de49",
	"./title-format-al-bronzo-cmp.vue": "de49",
	"./title-format-cmp": "a551",
	"./title-format-cmp.vue": "a551",
	"./title-separator-cmp": "c3d2",
	"./title-separator-cmp.vue": "c3d2",
	"./title-text-cmp": "bd0c",
	"./title-text-cmp.vue": "bd0c",
	"./wysiwyg-cmp": "10cd",
	"./wysiwyg-cmp.vue": "10cd",
	"./youtube-media-player-cmp-extended": "6c5f",
	"./youtube-media-player-cmp-extended.vue": "6c5f"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6fd3";
module.exports = webpackAsyncContext;